

export const SlideInfos = [
    {
        title : "Plateforme de livraison de confiance",
        body : "NW Express permet à ses clients de développer facilement leur activité tout en maintenant la rapidité des opérations et la fiabilité des services."
    },
    {
        title : "Mettez des livraisons flexibles à la demande ou programmées",
        body : "Automatisez les expéditions, suivez les coursiers en temps réel où que vous soyez et permettez aux clients de laisser des commentaires instantanés sur leur expérience de livraison."
    },
    {
        title : "Appelez toutes vos livreurs facilement",
        body : "Organisez vos livraisons et vos données opérationnelles. Obtenez des informations précieuses grâce à nos analyses et rapports avancés."
    },
    {
        title : "Intégration rapide avec vos données",
        body : "Connectez-vous à vos systèmes existants en quelques minutes seulement, permettant une intégration transparente et une optimisation rapide des itinéraires."
    },
];